import React from "react"
import { Button, Col } from "react-bootstrap"
import ReactLoading from "react-loading"

import "./Buttons.css"
function BtnAdd({ size, onClick, isClicked, label, disabled, id }) {
  return (
    <Col className="p-1">
      {isClicked ? (
        <Button className="action-btn add loader" size={size} disabled id={id}>
          <ReactLoading type={"balls"} height={20} width={25} color="#000000" />
        </Button>
      ) : (
        <Button
          className="action-btn add"
          size={size}
          onClick={onClick}
          disabled={disabled}
          id={id}
        >
          {label}
        </Button>
      )}
    </Col>
  )
}

export default BtnAdd
